export const categories = [
  {
    id: 'brand-planning',
    name: '品牌策划',
    slug: 'brand-planning',
    description: '从品牌定位到视觉体系，为品牌构建完整传播策略',
    icon: 'ri-lightbulb-flash-line',
    color: 'primary',
  },
  {
    id: 'video-production',
    name: '视频制作',
    slug: 'video-production',
    description: '企业宣传片、短视频、TVC广告等专业影视制作',
    icon: 'ri-film-line',
    color: 'primary',
  },
  {
    id: 'social-media',
    name: '社交媒体',
    slug: 'social-media',
    description: '全平台账号运营、内容策划、粉丝增长与互动管理',
    icon: 'ri-share-circle-line',
    color: 'primary',
  },
  {
    id: 'digital-marketing',
    name: '数字营销',
    slug: 'digital-marketing',
    description: '精准投放、效果追踪、数据驱动的营销增长方案',
    icon: 'ri-bar-chart-grouped-line',
    color: 'primary',
  },
  {
    id: 'creative-design',
    name: '创意设计',
    slug: 'creative-design',
    description: '视觉设计、平面设计、UI/UX设计与创意物料开发',
    icon: 'ri-palette-line',
    color: 'primary',
  },
] as const;

export type CategoryId = typeof categories[number]['id'];